import { render, staticRenderFns } from "./TemperatureSummary.vue?vue&type=template&id=40c582ac&scoped=true&"
import script from "./TemperatureSummary.vue?vue&type=script&lang=js&"
export * from "./TemperatureSummary.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureSummary.vue?vue&type=style&index=0&id=40c582ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c582ac",
  null
  
)

export default component.exports